export function formatDate(value: string | Date, isTime?: boolean) {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  if (isTime) {
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day}`;
}

export function formatDateKor(value: string) {
  const date = new Date(value);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${month}월 ${day}일`;
}

export function formatDateWithDote(
  value: string | Date,
  isTime?: boolean,
  isYear: boolean = true,
) {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  if (isTime) {
    return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
  }

  if (!isYear) {
    return `${month}.${day}`;
  }
  return `${year}.${month}.${day}`;
}

export const formatDateWithDay = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
  const week = weekdays[date.getDay()];

  return `${year}.${month}.${day}(${week})`;
};

export function formatDateTime(value: string, isText?: boolean) {
  const date = new Date(value);

  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "오후" : "오전";
  const hours12 = hours > 12 ? hours - 12 : hours;

  const hoursStr = String(isText ? hours12 : hours).padStart(2, "0");

  if (isText) return `${ampm} ${hoursStr}시 ${minutes}분`;

  return `${hoursStr}:${minutes}`;
}

export function getDateWith9AMRule() {
  const today = new Date();

  const currentHour = today.getHours();
  if (currentHour < 9) {
    today.setDate(today.getDate() - 1);
  }

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getMileageHistoryDateRange(
  dailyDate: string,
  type: string,
): { startDate: Date; endDate: Date } {
  const [year, month, day] = dailyDate.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  const endDate = new Date(year, month - 1, day + 1, 9, 0, 0, 0);

  let startDate = new Date(year, month - 1, day, 0, 0, 0, 0);

  if (type === "DAY") {
    startDate = new Date(year, month - 1, day, 9, 0, 0, 0);
  } else if (type === "WEEK") {
    const dayOfWeek = date.getDay();
    const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    startDate = new Date(year, month - 1, day + diff, 9, 0, 0, 0);
  } else if (type === "MONTH") {
    startDate = new Date(year, month - 1, 1, 9, 0, 0, 0);
  }

  return { startDate, endDate };
}
